<div class="one" fxLayout="column" [formGroup]="SettingForm">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="email-input pr-1">
      <mat-label>Email System</mat-label>
      <mat-select
        formControlName="EMAILSYSTEM"
        placeholder="Email System"
        (selectionChange)="OnchnageEmailSystem($event)"
      >
        @for (val of emilSystem; track val) {
          <mat-option value="{{ val.VALUE }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div
    class="mt-4"
    fxLayout="row wrap"
    fxLayoutAlign="start center"
    fxLayoutGap="16px"
    fxFlex="1 0 auto"
  >
    <mat-form-field appearance="outline" class="email-input pr-1" fxFlex="30">
      <mat-label>Email Save Folder Location</mat-label>
      <input matInput formControlName="EMAILSAVEFOLDER" placeholder="Enter email path" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="email-input" fxFlex="30">
      <mat-label>Attachments Save Folder Location</mat-label>
      <input
        matInput
        formControlName="EMAILATTACHMENTSAVEFOLDER"
        placeholder="Enter attachment path"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" class="email-input" fxFlex="30">
      <mat-label>Email Save Strategy</mat-label>
      <mat-select formControlName="EMAILSAVESTRATEGY" placeholder="Email Save Strategy">
        @for (val of emailSaveStrategy; track val) {
          <mat-option value="{{ val.VALUE }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  @if (emailSystemType == 'SMTP') {
    <mat-dialog-actions class="popup_ftr justify-end!">
      <!-- <div class="right_popup_btn"> -->
      <button
        class="btn-add-2 email-input-2"
        [disabled]="isspinerConfig"
        matButton="filled"
        (click)="saveEmilaconfig()"
        cdkFocusInitial
      >
        @if (isspinerConfig) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Configure
      </button>
      <!-- <button fxFlex="20" class="pr-4 btn-add-2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
      <!-- </div> -->
    </mat-dialog-actions>
  }
  <div align="end">
    <mat-dialog-actions class="popup_ftr">
      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveEmail()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
</div>
